import { render, staticRenderFns } from "./dg-list-item.vue?vue&type=template&id=0982f9ca&scoped=true"
import script from "./dg-list-item.vue?vue&type=script&lang=js"
export * from "./dg-list-item.vue?vue&type=script&lang=js"
import style0 from "./dg-list-item.vue?vue&type=style&index=0&id=0982f9ca&prod&scoped=true&lang=css"
import style1 from "./dg-list-item.vue?vue&type=style&index=1&id=0982f9ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982f9ca",
  null
  
)

export default component.exports